import type { VoidFunctionComponent } from 'react';

import Loader from '../../../generic/Loader';
import type { AnyExportRequest, Category, ExportType, Issue } from '../../../../../shared/issuesV2';
import type { SetState } from '../../../../types';

import JiraTicketExportContent from './jira/JiraTicketExportContent';
import ManualLinkContent from './ManualLinkContent';

type Props = {
  exportType: ExportType;
  isShowing: boolean;
  issueCategory: Category;
  selectedIssuesCount: number;
  isLoading: boolean;
  setWarningMessage: SetState<string>;
  issues: Issue[] | null;
  setContent: SetState<AnyExportRequest>;
  jiraTicketCount?: number;
  setIsSubmitDisabled: SetState<boolean>;
  remediationVersion?: string;
};

const ExportIssueModalContent: VoidFunctionComponent<Props> = ({
  isShowing,
  exportType,
  issueCategory,
  selectedIssuesCount,
  isLoading,
  setWarningMessage,
  issues,
  setContent,
  jiraTicketCount,
  setIsSubmitDisabled,
  remediationVersion,
}) => {
  if (!isShowing || !issues) {
    return <Loader />;
  }

  if (exportType === 'jira') {
    return (
      <JiraTicketExportContent
        selectedIssuesCount={selectedIssuesCount}
        shouldDisableInputs={isLoading}
        issueCategory={issueCategory}
        isLoading={isLoading}
        issues={issues}
        setWarningMessage={setWarningMessage}
        setContent={setContent}
        jiraTicketCount={jiraTicketCount}
        setIsDisabled={setIsSubmitDisabled}
        remediationVersion={remediationVersion}
      />
    );
  }

  if (exportType === 'custom') {
    return (
      <ManualLinkContent
        setContent={setContent}
        setIsDisabled={setIsSubmitDisabled}
      />
    );
  }

  // This should never happen.
  return null;
};

export default ExportIssueModalContent;
